function renderSliders() {
	let swiper = new Swiper('.slider-home', {
		autoplay: {
			delay: 10000,
		},
		grabCursor: true,
		loop: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});
}